import { Icon20NotificationOutline } from '@vkontakte/icons';
import classNames from 'clsx';
import React, { memo, useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { EnvironmentSelectors } from 'reactApp/modules/environment/environment';
import { ECloudNewFeaturesActions, sendCloudNewFeaturesAnalytics } from 'reactApp/ui/CloudNewFeatures/CloudNewFeatures.analytics';
import {
    getCloudFeatures,
    getLoadedCloudFeatures,
    updateLoadedCloudFeaturesList,
} from 'reactApp/ui/CloudNewFeatures/CloudNewFeatures.helpers';

import styles from './FeaturesButton.css';

interface IProps {
    onClick?: () => void;
}

export const FeaturesButton = memo<IProps>(({ onClick }) => {
    const isPhone = useSelector(EnvironmentSelectors.isPhone);

    const features = getCloudFeatures();
    const loadedFeatures = getLoadedCloudFeatures();
    const hasNewFeatures = !features.every((item) => loadedFeatures.includes(item));

    const [showInformer, setShowInformer] = useState(hasNewFeatures);

    useEffect(() => {
        sendCloudNewFeaturesAnalytics({ action: ECloudNewFeaturesActions.show });
    }, []);

    const handleClick = useCallback(() => {
        if (hasNewFeatures) {
            updateLoadedCloudFeaturesList();
        }
        setShowInformer(false);
        sendCloudNewFeaturesAnalytics({ action: ECloudNewFeaturesActions.click });
        onClick?.();
    }, [setShowInformer, onClick, hasNewFeatures]);

    return (
        <div
            className={classNames(styles.root, {
                [styles.root_mobile]: isPhone,
            })}
            onClick={handleClick}
        >
            <Icon20NotificationOutline />
            {showInformer && <div className={styles.informer} />}
        </div>
    );
});

FeaturesButton.displayName = 'FeaturesButton';
